import homeView from '../views/home';
import interviewView from '../views/interview';
import filmView from '../views/film';
import audioStoryView from '../views/audio-story';
import galleryView from '../views/gallery';
import opEdView from '../views/op-ed';
import essayView from '../views/essay';
import fictionView from '../views/fiction';
import featureView from '../views/feature';
import poemView from '../views/poem';
import eventsView from '../views/events';
import eventView from '../views/event';
import printView from '../views/print';
import singlePrintView from '../views/single-print';
import practiceView from '../views/practice';
import podcastsView from '../views/podcasts';
import treeMigration from './tree-migration';
import soundtrackView from '../views/soundtrack';
import vol3Opening from './vol-3-opening';
import vol3Chapter from './vol-3-chapter';
import vol3Prelude from './vol-3-prelude';
import pollinatorsView from './pollinators';
import pollinatorsChapterView from './pollinators-chapter';
import valemonTheBearView from './valemon-the-bear';
import londonExhibitionView from './london-exhibition';
import breathingWithTheForestView from './breathing-with-the-forest';
import filmSeriesSingleView from './film-series-single';
import filmSeriesLandingView from './film-series-landing';
import filmSeriesEngage from './film-series-engage';

export default [
	homeView,
	interviewView,
	filmView,
	audioStoryView,
	galleryView,
	opEdView,
	essayView,
	fictionView,
	featureView,
	poemView,
	eventsView,
	eventView,
	printView,
	singlePrintView,
	practiceView,
	podcastsView,
	treeMigration,
	soundtrackView,
	vol3Opening,
	vol3Chapter,
	vol3Prelude,
	pollinatorsView,
	pollinatorsChapterView,
	valemonTheBearView,
	londonExhibitionView,
	breathingWithTheForestView,
	filmSeriesSingleView,
	filmSeriesLandingView,
	filmSeriesEngage,
];
